export const FIXED_TIMETABLE = [
  {
    routeId: '191',
    numBus: 2,
    stopList: [
      {
        direction: '1',
        stops: [
          '11381',
          '11181',
          '11369',
          '18149',
          '18151',
          '18171',
          '18181',
          '18191',
          '18211',
          '18201',
          '18199',
          '18189',
          '18179',
          '18159',
          '18141',
          '11361',
          '11189',
          '11389',
        ],
      },
    ],
    timetable: [
      {
        direction: '1',
        trips: [
          {
            blockId: '11912401',
            tripId: '19952155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '06:31:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '06:33:21',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '06:35:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '06:38:39',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '06:41:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '06:42:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '06:43:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '06:44:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '06:45:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '06:47:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '06:49:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '06:50:12',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '06:51:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '06:53:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '06:55:24',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '06:57:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '06:58:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '07:01:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '0',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912402',
            tripId: '20422155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '06:51:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '06:53:21',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '06:55:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '06:58:39',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '07:01:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '07:03:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1245',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '07:04:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '07:05:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1290',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '07:07:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1320',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '07:09:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1320',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '07:11:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1320',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '07:12:21',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1329',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '07:13:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1335',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '07:15:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1350',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '07:18:12',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1368',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '07:20:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1380',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '07:22:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1425',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '07:26:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1500',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912403',
            tripId: '20202155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '07:11:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '07:13:21',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '07:15:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '07:18:39',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '07:21:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '07:23:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '07:24:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '07:25:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '07:27:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '07:29:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '07:31:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '07:32:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1209',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '07:33:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1215',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '07:36:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1230',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '07:39:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1248',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '07:41:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '07:43:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1283',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '07:48:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1320',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912401',
            tripId: '19967155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '07:31:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '07:33:35',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1214',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '07:35:32',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1225',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '07:39:25',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1246',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '07:42:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '07:44:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '07:45:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '07:46:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '07:48:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '07:50:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '07:52:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '07:53:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '07:54:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '07:57:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '08:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '08:02:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '08:05:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1282',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '08:10:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1320',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912402',
            tripId: '20437155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '07:46:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '07:48:35',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '07:50:32',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '07:54:25',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '07:57:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '07:59:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '08:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '08:01:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '08:03:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '08:05:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '08:07:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '08:08:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '08:09:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '08:12:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '08:15:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '08:17:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '08:20:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '08:25:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912403',
            tripId: '20217155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '08:01:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '08:03:49',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '914',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '08:05:57',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '925',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '08:10:11',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '946',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '08:13:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '960',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '08:15:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '960',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '08:16:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '960',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '08:17:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '960',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '08:19:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '960',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '08:21:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '960',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '08:23:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '960',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '08:24:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '960',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '08:25:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '960',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '08:28:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '960',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '08:31:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '960',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '08:33:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '960',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '08:35:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '938',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '08:40:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912401',
            tripId: '19982155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '08:16:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '08:18:49',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '08:20:57',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '08:25:11',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '08:28:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '08:30:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '08:31:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '08:32:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '08:34:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '08:36:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '08:38:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '08:39:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '08:40:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '08:43:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '08:46:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '08:48:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '08:50:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '08:55:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912402',
            tripId: '20452155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '08:31:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '08:33:49',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '08:35:57',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '08:40:11',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '08:43:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '08:45:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '08:46:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '08:47:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '08:49:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '08:51:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '08:53:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '08:54:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '08:55:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '08:58:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '09:01:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '09:03:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '09:05:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '09:10:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912403',
            tripId: '20232155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '08:46:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '08:48:49',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '08:50:57',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '08:55:11',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '08:58:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '09:00:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '09:01:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '09:02:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '09:04:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '09:06:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '09:08:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '09:09:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '09:10:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '09:13:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '09:16:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '09:18:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '09:20:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '09:25:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912401',
            tripId: '19997155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '09:01:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '09:03:35',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '886',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '09:05:32',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '875',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '09:09:25',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '854',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '09:12:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '09:14:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '09:15:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '09:16:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '09:18:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '09:20:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '09:22:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '09:23:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '09:24:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '09:27:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '09:30:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '09:32:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '09:34:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '09:39:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912402',
            tripId: '20467155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '09:16:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '09:18:35',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '09:20:32',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '09:24:25',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '09:27:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '09:29:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '09:30:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '09:31:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '09:33:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '09:35:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '09:37:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '09:38:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '09:39:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '09:42:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '09:45:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '09:47:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '09:49:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '09:54:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912403',
            tripId: '20247155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '09:31:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '09:33:21',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '886',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '09:35:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '875',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '09:38:39',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '854',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '09:41:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '09:42:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '818',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '09:43:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '810',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '09:44:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '795',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '09:46:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '780',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '09:48:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '780',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '09:50:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '780',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '09:51:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '780',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '09:52:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '780',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '09:55:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '780',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '09:58:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '780',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '10:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '780',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '10:03:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '802',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '10:08:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912401',
            tripId: '20012155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '09:51:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '09:53:21',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '09:55:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '09:58:39',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '10:01:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '10:02:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '10:03:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '10:04:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '10:06:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '10:08:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '10:10:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '10:11:21',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1191',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '10:12:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1185',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '10:14:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1170',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '10:17:12',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1152',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '10:19:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '10:22:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '10:27:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912402',
            tripId: '20482155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '10:11:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '10:13:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1186',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '10:14:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1175',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '10:17:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1154',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '10:20:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '10:21:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '10:22:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '10:23:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '10:25:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '10:27:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '10:29:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '10:30:21',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '10:31:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '10:33:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '10:36:12',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '10:38:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '10:41:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '10:46:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912401',
            tripId: '20027155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '10:31:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '10:33:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '10:34:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '10:37:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '10:40:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '10:41:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '10:42:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '10:43:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '10:45:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '10:47:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '10:49:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '10:50:21',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '10:51:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '10:53:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '10:56:12',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '10:58:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '11:01:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '11:06:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912403',
            tripId: '20262155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '10:51:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '10:53:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '10:54:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '10:57:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '11:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '11:01:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '11:02:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '11:03:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '11:05:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '11:07:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '11:09:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '11:10:21',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '11:11:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '11:13:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '11:16:12',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '11:18:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '11:21:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '11:26:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912402',
            tripId: '20497155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '11:11:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '11:13:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '11:14:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '11:17:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '11:20:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '11:21:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '11:22:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '11:23:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '11:25:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '11:27:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '11:29:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '11:30:21',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '11:31:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '11:33:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '11:36:12',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '11:38:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '11:41:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '11:46:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912401',
            tripId: '20042155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '11:31:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '11:33:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '11:34:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '11:37:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '11:40:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '11:41:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '11:42:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '11:43:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '11:45:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '11:47:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '11:49:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '11:50:21',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '11:51:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '11:53:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '11:56:12',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '11:58:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '12:00:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1178',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '12:05:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912403',
            tripId: '20277155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '11:51:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '11:53:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '11:54:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '11:57:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '12:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '12:01:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '12:02:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '12:03:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '12:05:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '12:07:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '12:09:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '12:10:21',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '12:11:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '12:13:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '12:16:12',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '12:18:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '12:20:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '12:25:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912401',
            tripId: '20057155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '12:11:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '12:13:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '12:14:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '12:17:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '12:20:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '12:21:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '12:22:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '12:23:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '12:25:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '12:27:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '12:29:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '12:30:21',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '12:31:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '12:33:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '12:36:12',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '12:38:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '12:40:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '12:45:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912402',
            tripId: '20512155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '12:31:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '12:33:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '12:34:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '12:37:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '12:40:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '12:41:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '12:42:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '12:43:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '12:45:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '12:47:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '12:49:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '12:50:21',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '12:51:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '12:53:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '12:56:12',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '12:58:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '13:00:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '13:05:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912403',
            tripId: '20292155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '12:51:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '12:53:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '12:54:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '12:57:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '13:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '13:01:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '13:02:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '13:03:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '13:05:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '13:07:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '13:09:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '13:10:21',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '13:11:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '13:13:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '13:16:12',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '13:18:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '13:20:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '13:25:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912402',
            tripId: '20527155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '13:11:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '13:13:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '13:14:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '13:17:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '13:20:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '13:21:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '13:22:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '13:23:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '13:25:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '13:27:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '13:29:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '13:30:21',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '13:31:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '13:33:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '13:36:12',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '13:38:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '13:40:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '13:45:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912401',
            tripId: '20072155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '13:31:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '13:33:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '13:34:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '13:37:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '13:40:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '13:41:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '13:42:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '13:43:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '13:45:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '13:47:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '13:49:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '13:50:21',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '13:51:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '13:53:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '13:56:12',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '13:58:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '14:00:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '14:05:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912403',
            tripId: '20307155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '13:51:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '13:53:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '13:54:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '13:57:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '14:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '14:01:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '14:02:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '14:03:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '14:05:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '14:07:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '14:09:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '14:10:21',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '14:11:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '14:13:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '14:16:12',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '14:18:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '14:20:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '14:25:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912402',
            tripId: '20542155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '14:11:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '14:13:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '14:14:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '14:17:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '14:20:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '14:21:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '14:22:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '14:23:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '14:25:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '14:27:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '14:29:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '14:30:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1209',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '14:31:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1215',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '14:34:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1230',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '14:37:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1248',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '14:39:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '14:41:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '14:46:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912401',
            tripId: '20087155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '14:31:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '14:33:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '14:34:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '14:37:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '14:40:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '14:41:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '14:42:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '14:43:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '14:45:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '14:47:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '14:49:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '14:50:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '14:51:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '14:54:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '14:57:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '14:59:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '15:01:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '15:06:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912403',
            tripId: '20322155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '14:51:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '14:53:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '14:54:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '14:57:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '15:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '15:01:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '15:02:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '15:03:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '15:05:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '15:07:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '15:09:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '15:10:39',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1209',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '15:11:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1215',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '15:14:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1230',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '15:17:48',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1248',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '15:20:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '15:22:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '15:27:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912402',
            tripId: '20557155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '15:11:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '15:13:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '15:14:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '15:17:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '15:20:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '15:21:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '15:22:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '15:23:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '15:25:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '15:27:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '15:29:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '15:30:39',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '15:31:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '15:34:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '15:37:48',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '15:40:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '15:42:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '15:47:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912401',
            tripId: '20102155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '15:31:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '15:33:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '15:34:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '15:37:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '15:40:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '15:41:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '15:42:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '15:43:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '15:45:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '15:47:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '15:49:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '15:50:39',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '15:51:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '15:54:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '15:57:48',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '16:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '16:02:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '16:07:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912402',
            tripId: '20572155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '15:51:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '15:53:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '15:54:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '15:57:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '16:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '16:01:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '16:02:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '16:03:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '16:05:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '16:08:20',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1240',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '16:10:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '16:11:39',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '16:12:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '16:15:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '16:18:48',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '16:21:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '16:23:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '16:28:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912403',
            tripId: '20337155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '16:11:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '16:13:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '16:14:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '16:17:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '16:20:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '16:21:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '16:22:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '16:23:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '16:25:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '16:28:20',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '16:30:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '16:31:39',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '16:32:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '16:35:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '16:38:48',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '16:41:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '16:43:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '16:48:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912401',
            tripId: '20117155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '16:31:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '16:33:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '16:34:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '16:37:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '16:40:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '16:41:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '16:42:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '16:43:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '16:45:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '16:47:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1160',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '16:49:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '16:50:39',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '16:51:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '16:54:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '16:57:48',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '17:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '17:02:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '17:07:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912402',
            tripId: '20587155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '16:51:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '16:53:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '16:54:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '16:57:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '17:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '17:02:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1222',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '17:03:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1230',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '17:04:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1245',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '17:06:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '17:08:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '17:10:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '17:11:48',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1269',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '17:13:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1275',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '17:16:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1290',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '17:19:36',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1308',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '17:22:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1320',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '17:25:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1342',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '17:30:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1380',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912403',
            tripId: '20352155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '17:06:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '17:08:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '17:09:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '17:12:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '17:15:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '17:17:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '17:18:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '17:19:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '17:21:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '17:23:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '17:25:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '17:26:57',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '909',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '17:28:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '915',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '17:31:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '930',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '17:35:24',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '948',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '17:38:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '960',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '17:40:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '938',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '17:45:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912401',
            tripId: '20132155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '17:21:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '17:23:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '17:24:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '17:27:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '17:30:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '17:32:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '17:33:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '17:34:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '17:36:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '17:39:20',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '940',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '17:41:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '960',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '17:42:57',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '960',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '17:44:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '960',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '17:47:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '960',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '17:51:24',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '960',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '17:54:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '960',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '17:56:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '960',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '18:01:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '960',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912402',
            tripId: '20602155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '17:36:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '17:38:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '17:39:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '17:42:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '17:45:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '17:47:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '17:48:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '17:49:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '17:51:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '17:54:20',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '17:56:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '17:58:06',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '909',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '17:59:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '915',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '18:03:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '930',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '18:07:12',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '948',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '18:10:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '960',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '18:12:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '960',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '18:17:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '960',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912403',
            tripId: '20367155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '17:51:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '17:53:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '17:54:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '17:57:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '18:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '18:02:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '18:03:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '18:04:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '18:06:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '18:08:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '860',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '18:10:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '18:12:06',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '18:13:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '18:17:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '18:21:12',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '18:24:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '18:26:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '18:31:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912401',
            tripId: '20147155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '18:06:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '18:08:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '18:09:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '18:12:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '18:15:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '18:17:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '18:18:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '18:19:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '18:21:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '18:23:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '18:25:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '18:26:57',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '891',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '18:28:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '885',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '18:31:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '870',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '18:35:24',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '852',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '18:38:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '18:40:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '18:45:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912402',
            tripId: '20617155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '18:21:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '18:23:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '18:24:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '18:27:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '18:30:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '18:32:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '18:33:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '18:34:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '18:36:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '18:38:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '18:40:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '18:41:57',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '18:43:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '18:46:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '18:50:24',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '18:53:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '18:55:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '877',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '18:59:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912403',
            tripId: '20382155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '18:36:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '18:38:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '18:39:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '18:42:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '18:45:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '18:47:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '18:48:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '18:49:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '18:51:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '18:53:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '18:55:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '18:56:48',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '891',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '18:58:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '885',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '19:01:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '870',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '19:04:36',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '852',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '19:07:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '19:09:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '863',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '19:14:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912401',
            tripId: '20162155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '18:51:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '18:53:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '18:54:42',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '18:57:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '19:00:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '900',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '19:01:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '878',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '19:02:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '870',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '19:03:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '855',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '19:05:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '19:07:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '19:09:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '840',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '19:10:39',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '831',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '19:11:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '825',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '19:14:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '810',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '19:17:48',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '792',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '19:20:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '780',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '19:22:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '780',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '19:27:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '780',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912402',
            tripId: '20632155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '19:11:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '19:12:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1186',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '19:14:18',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1176',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '19:17:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1154',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '19:19:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '19:20:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '19:21:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '19:22:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '19:24:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '19:26:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '19:28:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '19:29:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1131',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '19:30:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1125',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '19:33:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1110',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '19:36:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1092',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '19:38:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1080',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '19:40:38',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1080',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '19:45:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1080',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912403',
            tripId: '20397155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '19:31:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '19:32:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '19:34:18',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '19:37:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '19:39:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '19:40:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '19:41:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '19:42:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '19:44:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '19:46:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '19:48:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '19:49:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '19:50:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '19:53:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '19:56:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '19:58:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '20:00:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1177',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '20:04:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912401',
            tripId: '20177155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '19:51:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '19:52:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '19:54:18',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '19:57:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '19:59:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '20:00:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '20:01:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '20:02:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '20:04:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '20:06:40',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '20:08:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '20:09:21',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1191',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '20:10:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1185',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '20:12:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1170',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '20:15:12',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1152',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '20:17:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '20:19:15',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '20:23:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1140',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
          {
            blockId: '11912402',
            tripId: '20647155191',
            stops: [
              {
                stopId: '11381',
                stopSequence: 1,
                schArrTime: '20:11:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11181',
                stopSequence: 2,
                schArrTime: '20:13:21',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1228',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11369',
                stopSequence: 3,
                schArrTime: '20:15:07',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1249',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18149',
                stopSequence: 4,
                schArrTime: '20:18:39',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1292',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18151',
                stopSequence: 5,
                schArrTime: '20:21:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1320',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18171',
                stopSequence: 6,
                schArrTime: '20:22:53',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1320',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18181',
                stopSequence: 7,
                schArrTime: '20:23:30',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1320',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18191',
                stopSequence: 8,
                schArrTime: '20:24:45',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1320',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18211',
                stopSequence: 9,
                schArrTime: '20:26:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1320',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18201',
                stopSequence: 10,
                schArrTime: '20:28:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1280',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18199',
                stopSequence: 11,
                schArrTime: '20:29:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1260',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '18189',
                stopSequence: 12,
                schArrTime: '20:30:12',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1251',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18179',
                stopSequence: 13,
                schArrTime: '20:31:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1245',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18159',
                stopSequence: 14,
                schArrTime: '20:33:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1230',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '18141',
                stopSequence: 15,
                schArrTime: '20:35:24',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1212',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11361',
                stopSequence: 16,
                schArrTime: '20:37:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1200',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
              {
                stopId: '11189',
                stopSequence: 17,
                schArrTime: '20:38:08',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1133',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 0,
              },
              {
                stopId: '11389',
                stopSequence: 18,
                schArrTime: '20:40:00',
                obsArrTime: null,
                busRegNo: null,
                driverId: null,
                driverName: null,
                plannedHeadway: '1020',
                observedHeadway: null,
                headwayDeviation: null,
                itp: 1,
              },
            ],
          },
        ],
      },
    ],
  },
];
